module.exports = __webpack_public_path__ + "static/media/LHOutSwing.bc00fa73.svg";